var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "healthcheck-container" },
    [
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c(
            "label",
            {
              staticClass: "label-bold",
              attrs: { id: "view-closing-date-label" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.tenderCloseAt")) +
                  ":\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text", attrs: { id: "view-closing-date-value" } },
            [_vm._v("\n        " + _vm._s(_vm.showClosingDate()) + "\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.firstIssuedDate,
                expression: "firstIssuedDate",
              },
            ],
            staticClass: "row",
          },
          [
            _c(
              "label",
              { staticClass: "label-bold", attrs: { id: "view-issued-label" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.firstIssuedOn")) +
                    ": \n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text", attrs: { id: "view-issued-date-value" } },
              [_vm._v("\n        " + _vm._s(_vm.firstIssuedDate) + "\n      ")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.lastIssuedDate,
                expression: "lastIssuedDate",
              },
            ],
            staticClass: "row",
          },
          [
            _c(
              "label",
              { staticClass: "label-bold", attrs: { id: "view-issued-label" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.lastIssuedOn")) +
                    ": \n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text", attrs: { id: "view-issued-date-value" } },
              [_vm._v("\n        " + _vm._s(_vm.lastIssuedDate) + "\n      ")]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.status === _vm.tenderStatus.ISSUED
          ? _c("div", [
              _c(
                "label",
                {
                  staticClass: "days-left",
                  attrs: { id: "view-days-left-label" },
                },
                [_c("span", [_vm._v(_vm._s(_vm.timeLeft))])]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === _vm.tenderStatus.READY
          ? _c("div", [
              _c("label", { staticClass: "ready-for-review" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.readyForReview")) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "onsite-visit" }, [
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.general.onsiteVisitRequired,
                expression: "general.onsiteVisitRequired",
              },
            ],
            attrs: {
              id: "view-closing-date-onsite-visit-required",
              type: "checkbox",
              disabled: "",
            },
            domProps: {
              checked: Array.isArray(_vm.general.onsiteVisitRequired)
                ? _vm._i(_vm.general.onsiteVisitRequired, null) > -1
                : _vm.general.onsiteVisitRequired,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.general.onsiteVisitRequired,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.general,
                        "onsiteVisitRequired",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.general,
                        "onsiteVisitRequired",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.general, "onsiteVisitRequired", $$c)
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "text",
              attrs: { id: "view-closing-date-onsite-visit-required-label" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.general.onsiteVisitRequired")) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.general.onsiteVisitRequired
          ? _c("div", [
              _c("div", [
                _c(
                  "label",
                  {
                    staticClass: "label-bold",
                    attrs: { id: "view-closing-date-onsite-location-label" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tender.general.onSiteLocation")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "text onsite-contact",
                    attrs: { id: "view-closing-date-onsite-location-value" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.general.onsiteLocation) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "label",
                  {
                    staticClass: "label-bold",
                    attrs: { id: "view-closing-date-onsite-contact-label" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tender.general.onSiteContact")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "text",
                    attrs: { id: "view-closing-date-onsite-contact-name" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.onsiteContact.name) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "text",
                    attrs: { id: "view-closing-date-onsite-contact-email" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.onsiteContact.email) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "text",
                    attrs: { id: "view-closing-date-onsite-contact-phone" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.onsiteContact.phone) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("VendorBidStatusTable"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }